<template>
	<div class="sidebar"></div>
</template>

<script>
export default {
	name: 'employeeSidebar',
};
</script>

<style lang="scss" scoped>
.sidebar {
	position: relative;
	width: 100%;
	flex: 0 0 20%;
	max-width: 20%;
	height: 100vh;
	padding-right: 15px;
	padding-left: 15px;
	padding-top: 15px;
}
</style>
